import { ButtonContainer, Header, Icon, Title } from './styles';
import React, { ReactNode } from 'react';

type HeaderPageProps = {
	icon?: string;
	svgIcon?: any;
	title: string;
	className?: string;
	buttons?: Array<{
		content: ReactNode;
		visible: boolean;
	}>;
};

const HeaderPage = ({
	className,
	title,
	icon,
	svgIcon: SVG,
	buttons,
}: HeaderPageProps): JSX.Element => {
	return (
		<Header className={className}>
			<div>
				{icon && <Icon src={icon} alt="Icon" id="header-icon" />}
				{!icon && SVG}
				<Title>{title}</Title>
			</div>
			<ButtonContainer>
				{buttons?.map((button) => {
					if (!button.visible) return;
					return button.content;
				})}
			</ButtonContainer>
		</Header>
	);
};

export default HeaderPage;
